<template>
  <div class="checkbox-container" style="position:relative;">
    <label class="el-checkbox">
      <span class="el-checkbox__input" :class="{'is-checked':visible}">
        <span class="el-checkbox__inner"></span>
        <input
          @change="changeCheckBox"
          type="checkbox"
          aria-hidden="false"
          class="el-checkbox__original"
          value
        />
      </span>
      <span class="el-checkbox__label">
        <slot></slot>
      </span>
    </label>
    <div class="tipBox" @click="goUrl('http://www.peugeot.com.cn/homepage/legal.html','tip')">&nbsp;</div>
  </div>
</template>
<script>
import tipDialog from "@/components/dialog/appoint/tip";
import { goUrl } from "@/utils/hybird"
export default {
  props: ["value"],
  data() {
    return {
      visible: false
    };
  },
  created() {
    this.visible = this.value;
  },
  methods: {
    goUrl(url,linkId){
      // goUrl(url,linkId)
      tipDialog();
    },
    changeCheckBox() {
      this.visible = !this.visible;
      this.$emit("input", this.visible);
    }
  }
};
</script>
<style lang="less" scoped="true">
.rem(@name,@px) {
    @{name}: unit(@px / 37.5, rem);
}
.checkbox-container{
  display: grid;
  margin-left:15px;
  grid-template-columns: 50px auto;
}
.tipBox {
  height: 40px;
  position: relative;
  z-index:20;
  width:160px;
  left:30px;
}
.el-checkbox {
  color: #fff !important;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  display: flex;
  height: 40px;
  width: 314px;
  user-select: none;
  align-items: center;
}
.el-checkbox__input {
  cursor: pointer;
  outline: none;
  display: inline-block;
  line-height: 1;
  position: relative;
  top:-12px;
  vertical-align: middle;
  left:28px;
}
.el-checkbox__inner {
  display: inline-block;
  position: relative;
  border-radius: 0;
  box-sizing: border-box;
  width:12px;
  height:12px;
  background-color: transparent;
  border:1px solid #9799A6;
  background-size: 100% 100%;
  z-index: 1;
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
    display: flex;
    align-items: center;
    justify-content: center;
}
.el-checkbox__input.is-checked .el-checkbox__inner:after {
  content:"";
  display: block;
  // background:url('../../../../assets/img/check.png') no-repeat;
  // background-size:100%;
  width:8px;
  height:8px;
  background-color:#B10606;
}
.el-checkbox__original {
  opacity: 0;
  outline: none;
  position: absolute;
  margin: 0;
  width: 0;
  height: 0;
  z-index: -1;
}
.el-checkbox__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
  font-size: 9px;
  width: 100px;
}
</style>
